import React from 'react';
import { Link } from 'gatsby';
import dayjs from 'dayjs';

import css from './Footer.module.css';

import EuroMomoInvert from '../images/euromomo-invert.svg';
import SSILogo from '../images/ssi-logo.svg';

const Footer = ({ node, list }) => {
	return (
		<footer className={css.root}>
			<div className={css.left}>
				<Link to="/" className={css.logo}>
					<EuroMomoInvert height={40} />
				</Link>
				<a href="https://en.ssi.dk/">
					<SSILogo height={40} />
				</a>
			</div>
			<div className={css.right}>
				<Link to="/about-us/contact/" className={css.contact}>
					Contact
				</Link>
				<span>All rights reserved ©{dayjs().year()}</span>
			</div>
		</footer>
	);
};

export default Footer;
